import { render, staticRenderFns } from "./examPointsLook.vue?vue&type=template&id=557dc0c9&scoped=true"
import script from "./examPointsLook.vue?vue&type=script&lang=js"
export * from "./examPointsLook.vue?vue&type=script&lang=js"
import style0 from "./examPointsLook.vue?vue&type=style&index=0&id=557dc0c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557dc0c9",
  null
  
)

export default component.exports